import { Grid, Typography } from "@material-ui/core";
import MaskService from "../../../../../utils/mask/maskService";
import { useFluxoDeCaixaService } from "../../contexts";

export const ReportFooter = () => {
  const { cachedTotalsData } = useFluxoDeCaixaService();

  return (
    <Grid item container xs>
      <Grid item xs={6}>
        <ul style={{ lineHeight: "180%", listStyle: "none", padding: 0 }}>
          <li>
            <Typography> &ndash; Total de Débitos:</Typography>
          </li>
          <li>
            <Typography> &ndash; Total de Créditos:</Typography>
          </li>
          <li>
            <Typography> &ndash; Saldo Período:</Typography>
          </li>
          <li>
            <Typography>
              &ndash; Total Contas não Pagas (Anterior ao período):
            </Typography>
          </li>
          <li>
            <Typography>
              &ndash; Total Títulos não Recebidos (Anterior ao período):
            </Typography>
          </li>
        </ul>
      </Grid>
      <Grid item xs={6}>
        <ul style={{ lineHeight: "180%", listStyle: "none" }}>
          <li>
            <Typography>
              {(
                parseFloat(cachedTotalsData?.CP || "0") +
                parseFloat(cachedTotalsData?.MBD || "0")
              ).toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
              })}
            </Typography>
          </li>
          <li>
            <Typography>
              {" "}
              R${" "}
              {MaskService.toMask(
                "decimal",
                (
                  parseFloat(cachedTotalsData?.CR || "0") +
                  parseFloat(cachedTotalsData?.MBC || "0")
                ).toFixed(2),
                2
              )}
            </Typography>
          </li>
          <li>
            <Typography>
              {parseFloat(cachedTotalsData?.balance ?? "0,00").toLocaleString(
                "pt-br",
                {
                  style: "currency",
                  currency: "BRL",
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </li>
          <li>
            <Typography>
              {parseFloat(cachedTotalsData?.openedCP ?? "0,00").toLocaleString(
                "pt-br",
                {
                  style: "currency",
                  currency: "BRL",
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </li>
          <li>
            <Typography>
              R${" "}
              {MaskService.toMask(
                "decimal",
                parseFloat(cachedTotalsData?.openedCR ?? "0,00").toFixed(2),
                2
              )}
            </Typography>
          </li>
        </ul>
      </Grid>
    </Grid>
  );
};
